import { useTravelataApiService } from '@/shared/composables/useTravelataApiService';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import type { Country, Destination } from '@/shared/model';
import { adaptDestinations } from './adapter';
import type { ApiOption } from './types';

const cache = new Map<string, ApiOption[]>();

export function clearOptionsCache(): void {
  cache.clear();
}

export async function getOptions(term: string, countries: Country[] = []): Promise<Destination[]> {
  const key = term.toLowerCase();

  const cached = cache.get(key);
  if (cached !== undefined) {
    return adaptDestinations(cached, countries);
  }

  try {
    const apiService = useTravelataApiService();
    const config = useTravelataAppConfig();

    const response = await apiService.get<unknown>(config.intelligentSearch, {
      params: { term: key, clientUUID: config.clientUuid },
    });

    const list: ApiOption[] = Array.isArray(response)
      ? (response as ApiOption[])
      : response && Array.isArray((response as { result?: unknown }).result)
      ? (response as { result: ApiOption[] }).result
      : [];

    cache.set(key, list);
    return adaptDestinations(list, countries);
  } catch {
    return [];
  }
}
